<template>
  <div class="login-panel">
    <p class="login-panel__title">{{isPasswordLogin ? '账号密码登录' : '手机验证码登录'}}</p>
    <p class="login-panel__change" @click="changeLogin">{{isPasswordLogin ? '手机验证码登录' : '账号密码登录'}}></p>

    <div v-show="!loading & !accountError">
      <div v-show="!isPasswordLogin" style="height: 436px">
        <div id="login-panel" class="login-panel__urs" style="height: 436px" ></div>
      </div>
      <div v-show="isPasswordLogin" class="login-panel_cnt">
        <input v-model="username" class="login-panel_input" type="text" placeholder="请输入账号" >
        <input v-model="password" class="login-panel_input" type="password" placeholder="请输入密码">
        <div class="login-panel_info">
          <div class="login-panel_error" v-if="error">{{error}}</div>
          <p class="check_password" @click="goCheckPassword">查询密码</p>
        </div>
        <div class="login-panel_btn" :class="{disabled: !isActive}" @click="handleLoginClick">{{ onceSubmit ? '登录中...': btnName}}</div>
      </div>
    </div>
    <div class="login-panel__loading"  v-show="loading && !accountError">
      <div class="loader"></div>
      <div class="login-panel_btn loading_btn">登录中...</div>
    </div>
    <div class="login-panel__account-error" v-if="accountError">
      <img class="error-icon" src="https://pandapub.nosdn.127.net/tmp1757489062_i9qxnb4btf0l4t_4trpr5a%3D%3D_2_1757485462_20.png" alt="no permission" />
      <div class="error-tip login-panel_error">{{accountError}}</div>
      <div class="login-panel_btn loading_btn" @click="handleClear">切换账号</div>
    </div>
  </div>
</template>

<script>
import { passLogin, getCourseUrl} from '@/api/api';
import { reportErrorEvent } from '@/common/js/track';

export default {
  name: 'loginPanel',
  props: {
    btnName: {
      type: String,
      default: '登录'
    },
    isTeacherLogin:{
      type: Boolean,
      default: false
    },
    loading:{
      type: Boolean,
      default: false
    },
    accountError: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isPasswordLogin:false,
      ursInstance: null,
      username: '',
      password: '',
      error: '',
      onceSubmit: false,
      loginTitle:'手机验证码登录'
    };
  },
  computed: {
    isActive() {
      return this.username && this.password;
    }
  },
  mounted() {
    this.initURS();
  },
  methods: {
    goCheckPassword () {
        const studentUrl = `${getCourseUrl()}guide/examAccount/index.html?type=qst`;
        const teacherUrl = `${getCourseUrl()}guide/examAccount/index.html?type=qth`;
        window.open(this.isTeacherLogin ? teacherUrl : studentUrl);
    },
    changeLogin() {
      if(this.loading) return
      this.isPasswordLogin = !this.isPasswordLogin;
      this.handleClear();
    },
    handleClear() {
      this.$emit('clear');
    },
    // 等待 URS 加载完成
    waitForURS() {
      return new Promise((resolve) => {
        if (window.URS) {
          resolve(window.URS);
          return;
        }

        const checkURS = setInterval(() => {
          if (window.URS) {
            clearInterval(checkURS);
            resolve(window.URS);
          }
        }, 100);
      });
    },

    async initURS() {
      try {
        await this.waitForURS();
        this.webLogin();
      } catch (error) {
        console.error('URS initialization failed:', error);
      }
    },

    webLogin() {
      this.ursInstance = new window.URS({
        newCDN:1, // 必须，代表使用的CDN是连通性更好的SNI域名
        version:4, // 必须，代表版本4
        // isHttps: 1,
        cookieDomain:'mathstalents.com', // 产品页面地址非163.com域名的必填，可填入的域名列表：https://urs.hz.netease.com/docDetail.html?pid=384#/
        // regCookieDomain:'mathstalents.com', // 产品页面地址非163.com域名的必填，可填入的域名列表：https://urs.hz.netease.com/docDetail.html?pid=384#/
        includeBox:'login-panel', // 必须，登陆框的外层节点的id
        product : 'athena', // 必填，申请的产品号，对应工单生成的配置product
        promark : 'KECwuAj',// 必填，申请的组件ID，被分派ID，对应工单生成的配置promark
        productKey: "7d869052bd5a408d9acb5831fd3a992f",
        domains: "youdao.com,mathstalents.com", // 登录成功后要设置哪些域cookie
        host : 'mathstalents.com',// 必填，产品域名，对应工单生成的配置host
        cssDomain: location.origin, //可选，产品自定义css的域名https://a.b.com，注意css的协议，必须是https协议
        cssFiles : process.env.VUE_APP_MODE !== 'online' ? '/style/urs-component_1.1.css' : '/style/urs-component_1.1.css',  //可选，产品自定义css的文件路径 /path/x.css,/path/xx.css，必须是https协议
        page : 'login',// 可选，首屏显示登录，可选register
        single : 1, // 可选，只接入登录或注册模块
        smsBtnTxt:'登录',
        mbBtnTxt:'登录',
        needMobileLogin: 1, // 需要手机帐号登录模块,【可选】
        mobileFirst: 1, // 手机帐号相关模块优先展示,【可选】
        smsLoginFirst: 1, // 优先短信登录方式,【可选】
        mbNeedItl: 1, // 手机帐号登录和注册是否支持国际手机号,【可选】
        mbOnlyItl: 1,
        noqr: 1, // 设置手机帐号是否隐藏二维码登录,【可选】
        // 手机验证码登录+注册模块相关配置，统一在uniteLogin对象下
        uniteLogin: {
          loginTxt: '登录', // 手机验证码登录按钮文案
          isItl: 1, // 是否国际号
          mbNeedItl: 1,
          mbOnlyItl: 1,
          first: 1, // 是否统一登录是首屏
          needClause: 0, // 是否需要条款
          placeholders: {
            mob: "请输入手机号码",
            sms: "请输入验证码"
          }
        },
        mbChangeModule:() => {
          // this.isPasswordLogin = true;
        },
        changepage:(cb) => {
          console.log(cb)
        },
        mbPwdLoginTxt:'账号密码登录>',
        mbSmsLoginTxt:'手机验证码登录>',
        mobilePlaceholder: {
          mobile: "请输入手机号码", // 手机密码登录文案
          pwd1: "请输入密码" // 手机密码登录文案
        },
        regcb:function(username){
          // 可选，注册成功回调，后续要使用组件要重新初始化
          console.log(username);
        },
        logincb : (_username,_isOther,_data) =>{
          // 可选，登录成功回调，后续要使用组件要重新初始化
          // 此时应该不让用户继续操作web组件
          // 隐藏登陆框或遮盖登陆框使用户无法继续操作，避免用户误认为登录失败了
          try{
            // 设置登录成功标识
            sessionStorage.setItem('loginSuccess', 'true');
            const tp = "urs-phone-web";
            const ru =encodeURIComponent(location.href);
            const url =
                "https://account.mathstalents.com/login/acc/login?app=web&product=DICT&tp=" +
                tp +
                "&fr=1&cf=7&ru=" +ru+"&version=2.0&samesite=true";
            console.log(url,'url========');
            location.href = url;
          }catch(e){
            this.$message.error('验证码登录失败,请使用账号密码登录')
            this.isPasswordLogin = true;
          }
          window.refresh(_username,_isOther);
        }
      });
    },
    handleLoginClick() {
      if (!this.isActive || this.onceSubmit) { return }
      this.onceSubmit = true;
      this.error = '';
      this.$emit('clear');
      passLogin(this.username, this.password,this.isTeacherLogin).then(res => {
        if (res?.body?.login) {
          localStorage.setItem('authHeader', res.body.auth);
          localStorage.setItem('userInfo', JSON.stringify({
            userName: this.username,
          }));
          this.$emit('loginSuccess');
        } else {
          this.error = '账号或密码错误';
          throw new Error('账号或密码错误');
        }
      }).catch(err => {
        console.error(err);
        reportErrorEvent({
          type: 'login_pass',
          username: this.username,
          password: this.password,
          error: err?.message || JSON.stringify(err),
        })
        this.error = err?.message || '系错出错，请稍后重试'
      }).finally(() => {
        this.onceSubmit = false;
      })
    },
  }
}
</script>

<style lang="less" scoped>
.login-panel {
  width: 100% !important;
  height: 100% !important;
  position: relative;
  &__loading{
    height: 100%;
    position: relative;
    .loader{
      width: 200px;
      height: 140px;
      background: rgba(212,212,212,0.5);
      box-sizing: border-box;
      position: absolute;
      border-radius:8px;
      perspective: 1000px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.8);
    }
    .loader:before{
      content: '';
      position: absolute;
      left: 10px;
      right: 10px;
      top: 10px;
      bottom: 10px;
      border-radius:8px;
      background: #f5f5f5  no-repeat;
      background-size: 60px 10px;
      background-image: 	linear-gradient(#ddd 100px, transparent 0) ,
      linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0);

      background-position: 15px 30px , 15px 60px , 15px 90px,
      105px 30px , 105px 60px , 105px 90px;
      box-shadow: 0 0 10px rgba(0,0,0,0.25);
    }
    .loader:after {
      content: '';
      position: absolute;
      width: calc(50% - 10px);
      right: 10px;
      top: 10px;
      bottom: 10px;
      border-radius: 8px;
      background: #fff no-repeat;
      background-size: 60px 10px;
      background-image: linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0),
      linear-gradient(#ddd 100px, transparent 0);
      background-position: 50% 30px ,50% 60px , 50%  90px;
      transform: rotateY(0deg );
      transform-origin: left center;
      animation: paging 1s linear infinite;
    }


    @keyframes paging {
      to {
        transform: rotateY( -180deg );
      }
    }
    .loading_btn{
      position: absolute;
      bottom:60px;
      transform: translateX(-50%);
      left: 50%;
    }
  }
  &__account-error {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 120px;
    .error-icon {
      width: 148px;
      margin-bottom: 10px;
    }
    .error-tip {
      font-weight: 500;
    }
  }
  &__title {
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: bold;
    line-height: 130%;
    color: #000000;
    position: absolute;
    left: 60px;
    top: 60px;
  }
  &__change{
    position: absolute;
    right: 60px;
    top: 66px;
    color: #86909C;
    font-size: 16px;
    line-height: 24px;
    font-family: 'PingFang SC';
    font-weight: 500;
    cursor: pointer;
  }
  &__urs {
    height: 436px;
  }
  &_cnt {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 60px;
    box-sizing: border-box;
    top: 132px;
  }
  &_input {
    border-radius: 90px;
    background-color: #F5F6F9;
    width: 100%;
    height: 56px;
    margin-bottom: 16px;
    padding: 0 24px;
    box-sizing: border-box;
    border: none;
    font-size: 16px;
    display: flex;
    align-items: center;
    color: #202F42;
    outline: none;
    &:-webkit-autofill {
      caret-color: #202F42;
      -webkit-text-fill-color:#202F42;
      transition: background-color 50000s ease-in-out 0s;
    }
    &::placeholder {
      color: #C9CDD4;
    }
    &:focus-visible {
      outline: none;
    }

  }
  &_info{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .check_password{
      color: #3491FA;
      font-size: 15px;
      font-weight: 500;
      margin-left: auto;
      // text-align: right;
      // width: 100%;
    }
  }
  &_error {
    color: #FF6047;
    font-size: 14px;
    display: flex;
    align-items: center;
    // width: 100%;
    &::before {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('@/common/images/icon_danger.png') no-repeat center center / contain;
      vertical-align: top;
      margin-right: 4px;
    }
  }
  &_btn {
    border-radius: 28px;
    background: #000000;
    width: 300px;
    height: 56px;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 22px auto 0;
    position: relative;
    z-index: 99;
    &.disabled {
      opacity: 0.5;
    }
  }
  &_footer {
    margin-top: 30px;
    text-align: center;
    border-top: 1px solid #F1F1F6;
    padding-top: 14px;
    font-size: 12px;
    line-height: 14px;
    color: #B8BAC8;
    a {
      color: #4D9DFF
    }
  }
}
</style>
